
import React, { Component } from 'react'
import QueueAnim from 'rc-queue-anim';
import TweenOne from 'rc-tween-one';
//样式
import {
    Container
} from "./style";

//redux
import { connect } from 'react-redux'
import {ImageViewer, Ellipsis, Divider, Grid, Image, Toast,Dialog} from 'antd-mobile';
import {setVideoPlayData} from "../../components/VideoPlayer/store/actionCreators";
import {getHeaderData} from "../../common/Header/store/actionCreators";
import $axios from "../../request";
import {getUserInfoData} from "../../common/User/store/actionCreators";

class ImgVideoListItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            listItem:props.item,
            select:false,
            voteCount:null,
            animation:false,
            moment: null,
            paused: false,
            reverse: false,
            likeNum :0
        }
    }
    componentDidMount() {
        const {userInfo} = this.props;
        const {listItem} = this.state;
        if(userInfo&&listItem.voteState&&listItem.voteState===1){
            this.getCreationVoteCount();
        }

    }
    onRestart = () => {
        this.setState({
            paused: false,
            reverse: false,
            moment: 0,
        }, () => {
            this.setState({
                moment: null,
            });
        });
    }
    componentDidUpdate(nextProps: Readonly<P>, nextState: Readonly<S>, nextContext: any) {
        const {voteCount,listItem} = this.state;
        const userInfo = nextProps.userInfo;
        if(listItem.voteState&&listItem.voteState===1){
            if(voteCount===null){
                if(userInfo===null||userInfo===undefined){
                    this.props._getUserInfoData();
                }else{
                    this.getCreationVoteCount();
                }
            }
        }


    }


    handleFun(to) {
        to+='?&time='+Date.parse(new Date())
        this.props.history.push(to)

    }

    /**
     * 作品点赞数量
     */
     getCreationVoteCount=()=>{
         const {userInfo} = this.props;
         const {listItem} = this.state;
         const that = this;
        let url = '/vote/record/creation/count';
        let data = {userId:userInfo.id,creationId:listItem.id};
        $axios.postRequest(url, data)
            .then((response) => {
                console.log(url, response);
                let { errcode,data } = response
                if (response && response.succeed) {
                    if(data&&data>0){
                        that.setState({select:true,voteCount:data})
                    }

                }


            })
            .catch((error) => {
                console.log(url, error);

            });
    }

    /**
     * 投票
     */
    voteSubmit=()=>{
        const that = this;
        const {userInfo,activity} = this.props;
        const {listItem,likeNum} = this.state;
        that.setState({animation:true});
        this.onRestart();
        let url = '/vote/creation/app/likeYou';
        let data = {id:listItem.id,userId:userInfo.id};
        $axios.postRequest(url, data)
            .then((response) => {
                console.log(url, response);
                let { errcode,data } = response
                if (response && response.succeed) {
                    that.setState({voteCount:null,animation:false,
                        likeNum :likeNum+1})
                    //if(userInfo.userTypeEnum?.name ==='ORDINARY'){
                    if(window.ReactNativeWebView) {
                        if(userInfo.userTypeEnum?.name ==='ORDINARY'){
                            Toast.show({
                                icon: 'success',
                                content: '投票成功',
                            })
                        }else{
                            const handlerDialog =   Dialog.show({
                                content: '投票成功,获得一次抽奖机会',
                                closeOnAction: true,
                                actions: [
                                    {
                                        key: 'cancel',
                                        text: '继续投票',

                                    },
                                    {
                                        key: 'lottery',
                                        text: '去抽奖',
                                        bold: true,
                                        onClick:()=>{
                                            if(window.ReactNativeWebView) {
                                                window.ReactNativeWebView.postMessage("openLotteryPage")
                                            }else{
                                                this.props._getHeaderData({
                                                    title:'抽奖',
                                                    type: 0,
                                                    rightType: 0,
                                                    rightFun: {},
                                                    path: '/creationDetail/'+listItem?.id
                                                })
                                                this.handleFun('/iframe/lotteryPage')
                                            }
                                        }
                                    }
                                ],
                            })
                        }

                    }else{
                        Toast.show({
                            icon: 'success',
                            content: '投票成功',
                        })
                    }

                }else{
                    that.setState({animation:false})
                }


            })
            .catch((error) => {
                console.log(url, error);
                that.setState({animation:false})
            });
    }


    render() {
        let {
            listItem,
            select,
            likeNum
        } = this.state

        //console.log("listItem",listItem)
        return (
            <Container>

                {
                    listItem.voteTypeEnum?.name === 'IMG'&& <div
                        className='imgBg'
                        style={{backgroundImage: "url(" + listItem.imgPathShow[0].toImg() + ")",
                           }}
                        onClick={() => {
                            //ImageViewer.Multi.show({images:listItem.imgPathShow.toImg()});
                            this.handleFun('/creationDetail/'+listItem.id);
                        }}
                    >
                        <div  className='textLeftBottom'>
                            {/*&nbsp;{'编号:'+listItem.creationNo}*/}
                        </div>
                        <div  className='textRightBottom'>
                            {listItem.imgPathShow.length > 1 &&listItem.imgPathShow.length+'张图'}
                        </div>

                    </div>


                }
                {
                    listItem.voteTypeEnum?.name === 'VIDEO'&& <div
                        className='imgBg'
                        style={{backgroundImage: "url(" + listItem.vodCover.toImg() + ")",
                        }}
                        onClick={() => {

                            this.handleFun('/creationDetail/'+listItem.id);
                        }}
                    >

                        {/*<div  className='textLeftTopVideo'>*/}
                        {/*    /!*&nbsp;{'编号:'+listItem.creationNo}*!/*/}
                        {/*</div>*/}
                        <div  className='textLeftBottomVideo'>
                            <img
                                src={require("assets/images/play.png")}
                                width={64}
                                height={64}
                                fit='cover'
                            />
                        </div>



                    </div>


                }
                {
                    listItem.voteTypeEnum?.name === 'AUDIO'&& <div
                        className='imgBg'
                        style={{backgroundImage: "url(" + listItem.vodCover.toImg() + ")",
                        }}
                        onClick={() => {
                            //ImageViewer.Multi.show({images:listItem.imgPathShow.toImg()});
                            this.handleFun('/creationDetail/'+listItem.id);
                        }}
                    >
                        <div  className='textCenterVideo'>
                            <img
                                src={require("assets/images/audioPlay.png")}
                                width={64}
                                height={64}
                                fit='cover'
                            />
                        </div>

                    </div>


                }

                {/*<img className='img'  src={listItem.img} fit='cover'*/}
                {/*     onClick={() => {*/}
                {/*         this.setState({imgVisible:true,imgVisibleUrl:listItem.img}) }}/>*/}
                {/*<Divider className='divider'/>*/}
                {/*标题*/}
                <Ellipsis className='title' direction='end' rows={2} content={'['+(listItem.creationNo+1)+']'+listItem.title} />

                <div className='grid'>
                    <Grid  columns={24} gap={8}>
                        <Grid.Item span={1}>
                        </Grid.Item>
                        <Grid.Item span={4}>
                            {listItem.profilePhoto?.length>0&&
                            <Image
                                width={32}
                                height={32}
                                fit='contain'
                                style={{ borderRadius: 16 }}
                                src={listItem.profilePhoto.toImg()}
                                onClick={() => {
                                    this.setState({imgVisible:true,imgVisibleUrl:listItem.profilePhoto.toImg()})
                                }}
                            />
                            }
                            {(listItem.profilePhoto===null||listItem.profilePhoto==='')&&
                            <Image
                                width={32}
                                height={32}
                                fit='contain'
                                style={{ borderRadius: 16 }}
                                src={require("assets/images/defaultAvatar.png")}
                                onClick={() => {
                                    this.setState({imgVisible:true,imgVisibleUrl:require("assets/images/defaultAvatar.png")})
                                }}
                            />
                            }
                        </Grid.Item>
                        <Grid.Item span={6}>
                            <Ellipsis className='userName margin8Auto' direction='end' rows={1} content={listItem.userName} />
                        </Grid.Item>
                        {listItem.voteState&&<Grid.Item span={5}>
                            <div className='voteCount margin8Auto'>{listItem.likeNum?listItem.likeNum+likeNum:0}</div>
                        </Grid.Item>}
                        {listItem.voteState&&<Grid.Item span={5}>
                            <TweenOne
                                key="button"
                                style={{ textAlign: 'center' }}
                                paused={this.state.paused}
                                reverse={this.state.reverse}
                                moment={this.state.moment}

                                animation={{ y: -30, opacity: 0, type: 'from', delay: 300 }}
                            >
                                {
                                    select?<Image src={require("assets/images/thumbs-up-selected.png")} className={'button'} style={{width: "25px"}} alt=""
                                                  onClick={()=>{
                                                      this.voteSubmit();
                                                  }}/>:<Image src={require("assets/images/thumbs-up.png")} className={'button'} style={{width: "25px"}} alt=""
                                                              onClick={()=>{
                                                                  this.voteSubmit();
                                                              }}/>
                                }
                            </TweenOne>

                        </Grid.Item>}


                    </Grid>
                </div>


            </Container>

        )
    }
}

const mapState =state => {

    return {
        userInfo:state.getIn(['user', 'userInfo']),
        activity:state.getIn(['activity', 'activitySelect'])
    }
}
const mapDispatch =dispatch => {
    return {
        _setVideoPlayData(data) {
            dispatch(setVideoPlayData(data))
        },
        _getHeaderData(data) {
            dispatch(getHeaderData(data))
        },
        _getUserInfoData(data) {
            dispatch(getUserInfoData(data))
        },

    }
}

export default connect(mapState, mapDispatch)(ImgVideoListItem)
